import { render, staticRenderFns } from "./ReCardTicketFaqEdit.vue?vue&type=template&id=d9dc2814&scoped=true"
import script from "./ReCardTicketFaqEdit.vue?vue&type=script&lang=js"
export * from "./ReCardTicketFaqEdit.vue?vue&type=script&lang=js"
import style0 from "./ReCardTicketFaqEdit.vue?vue&type=style&index=0&id=d9dc2814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dc2814",
  null
  
)

export default component.exports